import React, { useState, useEffect, useCallback} from 'react';
import TableModule from '../TableModule';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faCheck, faGears, faSearch } from '@fortawesome/free-solid-svg-icons';
import apiClient from "../../axios";
import SuccessNotification from "../Notifications/SuccessNotification";
import ErrorNotification from "../Notifications/ErrorNotification";
import LoginNotification from "../Notifications/LoginNotification";
import Loader from "../Loader";


const SyncProdPriceModal = ({ isVisible, onClose, onSuccess }) => {
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);
    const itemsPerPage = 10;
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [isLoginVisible, setIsLoginVisible] = useState(false);
    const [productTypeCode, setProductTypeCode] = useState("");
    const [productTypeData, setProductTypeData] = useState([]);

    const fetchAllData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await apiClient.get(`/product_price`);
            if (Array.isArray(response.data)) {
                setData(response.data);
                setTotalItems(response.data.length);
            } else {
                setData([response.data]);
                setTotalItems(1);
            }
        } catch (error) {
            console.error("Error al obtener los datos de modulos extras", error);
        } finally {
            setLoading(false);
        }
    }, []);

    const fetchProductTypes = useCallback(async () => {
        try {
            setLoading(true);
            const response = await apiClient.get(`/product_type`);
            if (Array.isArray(response.data)) {
                setProductTypeData(response.data);
                setProductTypeCode(response.data.code);
            } else {
                setProductTypeData([response.data]);
            }
        } catch (error) {
            console.error("Error al obtener los datos de Product Type: ", error);
        } finally {
            setLoading(false);
        }
    }, []);
    
    useEffect(() => {
        if (isVisible) fetchAllData();
    }, [isVisible, fetchAllData]);

    useEffect(() => {
        fetchProductTypes();
    }, [fetchProductTypes]);


    const handleSearch = useCallback(
        async () => {
            try {
                const params = new URLSearchParams();
                if (productTypeCode) params.append("search", productTypeCode);

                const response = await apiClient.get(`/product_price?${params.toString()}`);

                if (Array.isArray(response.data)) {
                    setData(response.data);
                    setTotalItems(response.data.length);
                } else {
                    setData([response.data]);
                    setTotalItems(1);
                }
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    console.error("Error al obtener los datos de Product Price: ", error);
                }
            }
        },
        [productTypeCode]
    );
    const handleFresh = async (code) => {
        handleSearch(1);
    };

    const handleFieldChange = (id, field, raw) => {
        const value = raw === "" ? "" : Number(raw);
        setData(prev =>
          prev.map(r =>
            r.id === id
              ? { ...r, [field]: value }
              : r
          )
        );
      };

    const handleSave = async () => {
        const payload = data.map(({ id, purchasePrice, perUserPrice, discount }) => ({
            id, purchasePrice, perUserPrice, discount
        }));
        try {
            setLoading(true);
            if (payload.length > 0) {
                const response = await apiClient.post('/product_price/update_bulk', payload);
                if (response.status === 200) {
                    setIsSuccessVisible(true);
                    onSuccess?.();
                    setTimeout(() => {
                        onClose();
                    }, 1000);
                }
            }
        } catch (error) {
            console.error("Error updating bulk:", error);
            setIsErrorVisible(true);
        } finally {
            setLoading(false);
        }
    };

    const columns =[
        { title: "Id", key: "id" },
        { title: "Descripción", key: "moduleTemplateDescription" },
        { title: "Precio de Compra", key: "purchasePrice" },
        { title: "Precio Unitario", key: "perUserPrice" },
        { title: "Descuento", key: "discount" }
    ];

    const renderRow = (item) => {
        const handleInputChange = (id, field, value) => {
            const regex = /^\d*\.?\d*$/;
            if (regex.test(value)) {
                handleFieldChange(id, field, value);
            }
        };

        return (
            <>
                <td>{item.id}</td>
                <td>{item.moduleTemplateDescription}</td>
                <td>
                    <input
                        type="text"
                        value={item.purchasePrice}
                        onChange={(e) => handleInputChange(item.id, "purchasePrice", e.target.value)}
                        className="table-input"
                    />
                </td>
                <td>
                    <input
                        type="text"
                        value={item.perUserPrice}
                        onChange={(e) => handleInputChange(item.id, "perUserPrice", e.target.value)}
                        className="table-input"
                    />
                </td>
                <td>
                    <input
                        type="text"
                        value={item.discount}
                        onChange={(e) => handleInputChange(item.id, "discount", e.target.value)}
                        className="table-input"
                    />
                </td>
            </>
        );
    };

    return (
        isVisible && (
            <div className="modal-overlay">
                <div className="modal-content-module">
                    <div className="modal-content-module-body">
                        <h3 className="modal-title ">Sincronización de Precios</h3>
                        <div className="filter-form">
                            <div className="basic-info-form-group">
                                <select
                                    value={productTypeCode}
                                    onChange={(e) => setProductTypeCode(e.target.value)}
                                >
                                    <option value="">Seleccione un Tipo de Contrato</option>
                                    {productTypeData.map((p) => (
                                        <option key={p.code} value={p.code}>
                                            {p.code}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <button className="basic-custom-button" onClick={handleFresh}>
                                <FontAwesomeIcon
                                    icon={faSearch}
                                    className="basic-shortcut-icon"
                                />
                                Buscar
                            </button>
                        </div>
                        <TableModule
                            title="Lista de Precios"
                            rows={data}
                            columns={columns}
                            icon={faGears}
                            renderRow={renderRow}
                            currentPage={currentPage}
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            onPageChange={setCurrentPage}
                            onRefresh={fetchAllData}
                            loading={loading}
                            select={false}
                        />
                    </div>
                    <div className="basic-form-footer">
                        <button
                            className="basic-custom-button"
                            onClick={onClose}
                        >
                            <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
                            Cancelar
                        </button>
                        <button className="basic-custom-button" onClick={handleSave}>
                            <FontAwesomeIcon icon={faCheck} className="basic-shortcut-icon" />
                            Aceptar
                        </button>
                    </div>
                </div>
                <SuccessNotification
                    message={"Información guardada exitosamente"}
                    isVisible={isSuccessVisible}
                    onClose={() => setIsSuccessVisible(false)}
                />
                <ErrorNotification
                    message={"Oops! Ocurrió un Problema"}
                    isVisible={isErrorVisible}
                    onClose={() => setIsErrorVisible(false)}
                />
                <LoginNotification
                    message="Vuelve a iniciar sesión"
                    isVisible={isLoginVisible}
                    onClose={() => setIsLoginVisible(false)}
                />
                {loading && <Loader />}
            </div>
        )
    );
};

export default SyncProdPriceModal;
